import { render, staticRenderFns } from "./EventModel.vue?vue&type=template&id=03b49dab&scoped=true"
import script from "./EventModel.vue?vue&type=script&lang=js"
export * from "./EventModel.vue?vue&type=script&lang=js"
import style0 from "./EventModel.vue?vue&type=style&index=0&id=03b49dab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b49dab",
  null
  
)

export default component.exports